















import { ref, computed, defineComponent, onMounted } from '@vue/composition-api';

export default defineComponent({
    name: "module-title", // ICP备案主页面
    components: {

    },
    props: {
        text: {
            type: String,
            default: '数据详情'
        },
        iconName: {
            type: String,
            default: ""
        },
        hover: {
            type: Boolean,
            default: false
        }
    }
})
